export function pickMimeType() {
  const candidates = ['audio/webm;codecs=opus', 'audio/webm']
  for (const m of candidates) {
    if (MediaRecorder.isTypeSupported(m)) return m
  }
  return undefined
}
